<template>
    <div class="newsDetail">
        <h1>{{newsInformation.title}}</h1>
        <p>{{newsInformation.add_time}} &nbsp; &nbsp; &nbsp; &nbsp;   {{$t('view_count')+'：'+ newsInformation.click}}</p>
        <div class="newsDetailContent" v-html="replaceHtml(newsInformation.content)"></div>
        <div class="near_news" v-if="newsInformation.recent.length > 0">
             <h3>{{$t('recent')}}</h3>
             <nearNewsList v-for="(n,i) in newsInformation.recent" :nearNews="n" :key="i"></nearNewsList>
         </div>
    </div>
</template>
<script>
    import nearNewsList from  '../../components/endPage/nearNewsList'
    export default {
        name: "newsDetail",
        components:{
            nearNewsList
        },
        data(){
            return {
                newsInformation:{
                    title:'',
                    recent:[]
                },
            }
        },
        created:function () {
            console.log(this.$route.params.id);
            this.getDetailInfo (this.$route.params.id);
            this.$store.commit("set_current", '-1');
            this.$store.commit("set_title", 'footerNav[1]');
        },
        methods:{
           getDetailInfo (id) {
               this.$http({
                   xhrFields: {
                       withCredentials: true
                   },
                   crossDomain: true,
                   method: "post",
                   url: this.weburl + "home/Other/getNews",
                   dataType: "json",
                   data: {
                       id: id,
                       lang : window.$lang
                   },
               })
                   .then(res => {
                       if (res.data.status === 1) {
                           console.log(res.data);
                           this.newsInformation=res.data.result;
                       }
                   })
                   .catch(err => {
                       console.log(err);
                   })
           },
            replaceHtml(text){
                var txt= this.htmlDecode(text).replace(/src="\/public/g,'src="'+this.weburl+'/public');
                console.log(txt);
                return txt;
            }
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            }

        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common';
    .newsDetail {
        width: @width;
        .box-sizing;
        padding: 20px 15px ;
        & > h1 {
            font-size: @font + .4;
            line-height: @font * 2;
            margin-bottom: 10px;
        }
        & > p {
            margin-bottom: 10px;
            font-size: @font - .2;
            color:@word;
            padding-bottom: 10px;
            .border-bottom;
        }
        .near_news {
            padding-top: 10px;
            border-top:1px solid tint(@word , 50%);
            h3 {
                color: @brick_red;
                font-size: @font;
            }
        }
    }
  /*  .newsDetailContent {
        padding: 10px  0 30px;
    }*/

</style>
<style >
    .newsDetailContent >>> img {
        width: 100%;
    }
     .newsDetailContent {
         line-height: 24px ;
     }
</style>
